export default __webpack_public_path__ + "static/media/Sign-up-Dark-business.d3af99df.svg";